import { LOCATION_CHANGE } from 'react-router-redux';
import { resetDateFilters } from '../main/reports/actions';

const resetDateFilterMiddleware = store => next => (action) => {
  next(action);
  switch (action.type) {
    case LOCATION_CHANGE:
      // POP is only possible during the initial page load meaning there's nothing to reset
      if (action.payload.pathname === '/reports' && action.payload.action !== 'POP') {
        store.dispatch(resetDateFilters());
      }
      break;
    default:
      break;
  }
};

export default resetDateFilterMiddleware;
